import React from 'react';
import { Action } from '../components/v2BaseComponents/ActionButtonLayout/types';
import { usePromptButton } from '../components/shared/PromptButton';
import { ContentStack } from '../components/v2BaseComponents/Stack';
import { getIntl } from '../utils/intl';

const intl = getIntl('useGuidanceAction', {
    guidance: 'Guidance',
});

export type UseGuidanceActionArgs = {
    title: string;
    content: React.ReactNode;
};

export type UseGuidanceActionReturnValue = {
    action: Action;
    Prompt: React.ReactNode;
};

export const useGuidanceAction = ({ title, content }: UseGuidanceActionArgs): UseGuidanceActionReturnValue => {
    const guidancePrompt = usePromptButton({
        promptTitle: title,
        promptHeaderIcon: 'Info',
        renderPromptContents: () => <ContentStack>{content}</ContentStack>,
    });

    return {
        action: {
            title: intl('guidance'),
            onPress: guidancePrompt.onPress,
            icon: 'Info',
        },
        Prompt: guidancePrompt.Prompt,
    };
};
